export default "__VITE_ASSET__10b9ea98__"